import React, { useState } from "react";
import "./login.css"; // New CSS file
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import useAuth from "../../../hooks/useAuth";
import { IReset } from "./IReset";
import utilValidations from "../../../common/utils/utilValidations";
import { useTranslateText } from "../../../hooks/userLanguageTranslate";



interface AboutProps {
    email_token: any; 
}
const ResetPassword:React.FC <AboutProps>= ({email_token}) => {

  const eventData: any = useSelector((state: RootState) => state.eventData);

  const [formData, setFormData] = useState<IReset>({
    newPassword: "",
    confirmPassword: "",
  });

  const [fieldErrors, setFieldErrors] = useState<{ [key: string]: string | null }>({});
  const [errorMessages, setErrorMessages] = useState<string[]>([]);
  const [successMessage, setSuccessMessage] = useState<string[]>([]);

  const { formValidateField } = utilValidations();
  const translateText = useTranslateText;
  const { resetPassword } = useAuth();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    const passError = formValidateField("password", value);

    setFieldErrors((prev) => ({
      ...prev,
      [name]: passError ?? null,
    }));

    setErrorMessages([]);
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessages([]);
    setSuccessMessage([]);

    if (!formData.newPassword || !formData.confirmPassword) {
      setErrorMessages(["All fields are required!"]);
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setErrorMessages(["Passwords do not match."]);
      return;
    }

    try {
      const response = await resetPassword(formData.newPassword,email_token);
      setSuccessMessage(response);
    } catch (error: any) {
      const errorData = error.response?.data;

      if (errorData?.status === "FAILED") {
        if (Array.isArray(errorData.data)) {
          const messages = errorData.data.map((err: any) =>
            typeof err.message === "string"
              ? err.message
              : err.message?.message ?? "An unknown error occurred."
          );
          setErrorMessages(messages);
        } else {
          setErrorMessages(["An error occurred. Please try again."]);
        }
      } else {
        setErrorMessages([
          typeof error.message === "string" ? error.message : "An unknown error occurred.",
        ]);
      }
    }
  };

  return (
    <div className="reset-page-wrapper">
      <div className="reset-container">
        <h2>Reset Password</h2>

        {/* Validation & Error Messages */}
        {fieldErrors.newPassword && <div className="error-text">{fieldErrors.newPassword}</div>}
        {fieldErrors.confirmPassword && (
          <div className="error-text">{fieldErrors.confirmPassword}</div>
        )}
        {!fieldErrors.newPassword &&
          !fieldErrors.confirmPassword &&
          errorMessages.map((msg, idx) => (
            <div key={idx} className="error-text">
              {msg}
            </div>
          ))}
        {successMessage.length > 0 && (
          <div className="success-text">{successMessage}</div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit} className="reset-form">
          <input
            type="password"
            name="newPassword"
            placeholder={translateText("new-password", "New Password")}
            className="form-input"
            onChange={handleChange}
            required
          />

          <input
            type="password"
            name="confirmPassword"
            placeholder={translateText("confirm-password", "Confirm Password")}
            className="form-input"
            onChange={handleChange}
            required
          />

          <input
            type="submit"
            value={translateText("reset-password-button", "Reset Password")}
            className="submit-btn"
            style={{ backgroundColor: eventData?.register_button_color || "#007bff" }}
          />

          <div className="reset-links">
            <a href="/login">
              {translateText("back-to-login-link-text", "Back to login")}
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
